// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV {
  background: #FFFFFF;
  min-height: 400px;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabHeader__pXeK\\+ {
  width: 100%;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabHeader__pXeK\\+ .CDARedactor_tabHeaderContent__fBkJv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabContent__26GvT {
  min-height: 58vh;
  height: 58vh;
  font-size: 12px;
  padding: 16px 24px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabContent__26GvT::-webkit-scrollbar {
  width: 4px;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabContent__26GvT::-webkit-scrollbar-thumb {
  background-color: #04867a;
  border-radius: 50px;
}
.CDARedactor_CDARedactor__xQNV\\+ .CDARedactor_TabCDARedactor__0AWaV .CDARedactor_tabContent__26GvT::-webkit-scrollbar-track {
  background: #e2e4e7;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TreatmentCDA/CDARedactor/CDARedactor.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,WAAA;AAAN;AAEM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAAR;AAII;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,yBAAA;EACA,mBAAA;AAJN;AAOI;EACE,mBAAA;AALN","sourcesContent":[".CDARedactor {\n  .TabCDARedactor {\n    background: #FFFFFF;\n    min-height: 400px;\n\n    .tabHeader {\n      width: 100%;\n\n      .tabHeaderContent {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n        padding: 16px 24px;\n      }\n    }\n\n    .tabContent {\n      min-height: 58vh;\n      height: 58vh;\n      font-size: 12px;\n      padding: 16px 24px;\n      overflow-x: hidden;\n      overflow-y: scroll;\n    }\n\n    .tabContent::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    .tabContent::-webkit-scrollbar-thumb {\n      background-color: #04867a;\n      border-radius: 50px;\n    }\n\n    .tabContent::-webkit-scrollbar-track {\n      background: #e2e4e7;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CDARedactor": `CDARedactor_CDARedactor__xQNV+`,
	"TabCDARedactor": `CDARedactor_TabCDARedactor__0AWaV`,
	"tabHeader": `CDARedactor_tabHeader__pXeK+`,
	"tabHeaderContent": `CDARedactor_tabHeaderContent__fBkJv`,
	"tabContent": `CDARedactor_tabContent__26GvT`
};
export default ___CSS_LOADER_EXPORT___;
